const isMobile = (width:number = 0,height:number = 0) : boolean => {
    if((window.innerWidth < width && window.innerHeight < height)){
        return true
    }else{
        return false
    }
}

export default isMobile